import { useMemo } from "react";
import { useMst } from "../../../stores/main";

/**
 * Hook to read the current scene duration state from the in-memory JSON draft.
 * The current draft JSON is the settled baseline; visual trim/extend states are
 * preview-only while a drag is in progress.
 */
export function useSceneTrimState(): {
  trimEnd: number | null;
  currentDuration: number;
  baselineDuration: number;
} {
  const {
    playerStore: { jsonFile },
  } = useMst();

  const result = useMemo(() => {
    const currentFile = jsonFile as { ip?: number; op?: number } | undefined;

    const currentStart = currentFile?.ip ?? 0;
    const currentEnd = currentFile?.op ?? 0;

    const currentDuration = Math.max(0, currentEnd - currentStart);

    return {
      trimEnd: null,
      currentDuration,
      baselineDuration: currentDuration,
    };
  }, [jsonFile]);

  return result;
}
